import React from 'react';
import AsyncActionButton from '../../../../button/AsyncActionButton';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import UtilitiesService from '../../../../../service/UtilitiesService';
import ShelbyDetailedBillModal from './ShelbyDetailedBillModal';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import AccountLinkForm from '../../../../form/AccountLinkForm';

class Shelby extends React.Component {
  constructor(props) {
    super(props);
    this.getBills = this.getBills.bind(this);
    this.state = {};
    this.comboFields = [
      {
        value: 'externalAccountId',
        display: 'External Account ID',
      },
      {
        value: 'customerId',
        display: 'Customer ID',
      },
    ];
  }

  SHELBY = 'shelby_tax';

  onAccountRowSelect(selectedRow) {
    const { accountRows, selectedAccount, } = this.state;

    if (selectedAccount && selectedAccount.id !== selectedRow.id) {
      this.resetBills();
    }

    const account = accountRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedAccount: account.raw,
    });
  }

  onBillRowSelect(selectedRow) {
    const { billRows, } = this.state;

    const bill = billRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedBill: bill.raw,
    });
  }

  getAccounts(event) {
    this.reset();
    const { search, combo, } = event;
    const criteria = {};
    criteria[combo.value] = search.value;
    criteria.serviceOfferingId = this.SHELBY;
    const headers = [];
    const rows = [];

    UtilitiesService.getUtilityAccountBySearch(criteria)
      .then((response) => {
        const { accounts, } = response.data;

        if (accounts && accounts.length > 0) {
          const exclusions = item => ![ 'customerIds', ].includes(item);
          const formattedAccounts = accounts.map((account) => {
            const values = ObjectUtils.filterObject(account, exclusions);
            return values;
          });
          ObjectUtils.toLargestKeySet(formattedAccounts.map(v => v.value)).forEach((key) => {
            headers.push({
              display: key,
              value: key,
            });
          });

          formattedAccounts.forEach((account) => {
            rows.push({
              value: Object.values(account.value),
              raw: account.raw,
            });
          });
        }

        this.setState({
          accountHeaders: headers,
          accountRows: rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  getBills(accountId) {
    this.resetBills();
    const criteria = {};
    criteria.accountId = accountId;
    criteria.serviceOfferingId = this.SHELBY;
    const headers = [];
    const rows = [];
    this.setState({
      isBillLoading: true,
    });
    UtilitiesService.getUtilityBillBySearch(criteria)
      .then((response) => {
        const { bills, } = response.data;
        if (bills !== null && bills.length > 0) {
          const inclusions = item => [ 'id', 'city', 'paid', 'value', 'dueDate', 'taxYear', ].includes(item);
          const formattedBills = bills.map((bill) => {
            const values = ObjectUtils.filterObject(bill, inclusions);
            return values;
          });
          ObjectUtils.toLargestKeySet(formattedBills.map(v => v.value)).forEach((key) => {
            headers.push({
              display: key,
              value: key,
            });
          });

          formattedBills.forEach((bill) => {
            rows.push({
              value: Object.values(bill.value),
              raw: bill.raw,
            });
          });
        }

        this.setState({
          billHeaders: headers,
          billRows: rows,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          isBillLoading: false,
        });
      });
  }

  showAccountDetails = (selectedAccount) => {
    const { isBillLoading, } = this.state;

    if (!selectedAccount) {
      return null;
    }
    const customerIds = ObjectUtils.formatStringAsJSONArray(selectedAccount.customerIds);
    return (
      <div className="container">
        <p>{`Selected ID: ${selectedAccount.id}`}</p>
        <hr />
        <div className="row">
          <div className="m-1">
            <AsyncActionButton
              onClick={() => this.getBills(selectedAccount.id)}
              contents="Show Bills"
              isLoading={isBillLoading}
              variant="primary"
              loadingVariant="secondary"
            />
          </div>
          <div className="m-1">
            <AccountLinkForm
              serviceOfferingId={this.SHELBY}
              id={selectedAccount.id}
              customerIds={customerIds}
            />
          </div>
        </div>
      </div>
    );
  };

  showBillDetails = (selectedBill) => {
    if (!selectedBill) {
      return null;
    }
    return (
      <div className="container">
        <p>{`Selected ID: ${selectedBill.id}`}</p>
        <hr />
        <div className="row">
          <div className="m-1">
            <ShelbyDetailedBillModal bill={selectedBill} />
          </div>
       </div>
      </div>
    );
  };

  reset() {
    this.setState({
      accountHeaders: [],
      accountRows: [],
      selectedAccount: null,
    });

    this.resetBills();
  }

  resetBills() {
    this.setState({
      billHeaders: [],
      billRows: [],
      selectedBill: null,
    });
  }

  render() {
    const {
      accountHeaders = [],
      accountRows = [],
      billHeaders = [],
      billRows = [],
      selectedAccount,
      selectedBill,
    } = this.state;

    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={event => this.getAccounts(event)} />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Tax Accounts" style={{ maxHeight: '300px', }}>
            <Grid
              headers={accountHeaders}
              rows={accountRows}
              onRowSelect={data => this.onAccountRowSelect(data)}
            />
          </FieldSet>
          {this.showAccountDetails(selectedAccount)}
        </div>
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Tax Bills" style={{ maxHeight: '300px', }}>
            <Grid
              headers={billHeaders}
              rows={billRows}
              onRowSelect={data => this.onBillRowSelect(data)}
            />
          </FieldSet>
          {this.showBillDetails(selectedBill)}
        </div>
      </div>
    );
  }
}

export default Shelby;
